import React, { useEffect, useRef } from 'react';

const ContenedorAnimacion = ({ animation, duration, delay, className, children }: { animation: string, duration: number, delay: number, className: string, children: React.ReactNode }) => {
    const wrapperRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate__animated', `animate__${animation}`, 'visible');
                    (entry.target as HTMLDivElement).style.animationDuration = `${duration}ms`;
                    (entry.target as HTMLDivElement).style.animationDelay = `${delay}ms`;
                    observer.unobserve(entry.target);
                }
            });
        });

        if (wrapperRef.current) observer.observe(wrapperRef.current);

        return () => {
            observer.disconnect();
        };
    }, [animation, duration, delay]);

    return (
        <div ref={wrapperRef} className={`${className} animate__animated animate__opacity-0`}>
            {children}
        </div>
    );
};

export default ContenedorAnimacion;